<template>
  <div class="fullPageLoader loading"></div>
</template>

<script>
import { mapState } from 'vuex';
import mixins from 'src/mixins.js';
import { ANALYTICS } from '../../firebase-config';

export default {
  mixins: [mixins],
  data() {
    return {};
  },
  computed: {
    ...mapState(['currentUser', 'workspaces', 'userInfoLoaded', 'userInfo', 'currentWorkspace']),
    userVerified: function () {
      return this.currentUser && this.currentUser.emailVerified;
    }
  },
  methods: {
    userInfoCheck: function () {
      this.subscribeAllWorkspacesMixin();
    },
    workspacesCheck: function () {
      this.setCurrentWorkspaceMixin();
    },
    currentWorkspaceCheck() {
      if (this.currentWorkspace && this.currentWorkspace.id) {
        this.$router.push('/' + this.currentWorkspace.id);
      }
    }
  },
  mounted() {
    if (!this.userVerified) {
      this.$router.push('/verify-user');
    }

    ANALYTICS.logEvent('page_view');
  }
};
</script>

<style scoped>
html,
body {
  height: 100%;
}
</style>
